import type { OngoingDownload } from '@mimir/client-common/model/ongoingDownload';
import type { ApplicationContext } from '@mimir/common/context/applicationContext';
import { getBasenameWithoutExtension } from '@mimir/common/platformAbstraction/pathComposition';
import { showToast, TOAST } from '@mimir/web/eventBus';
import isEmpty from 'lodash/isEmpty';

/**
 * Shows a success toast when a transfer completes, unless suppressed for batch imports.
 */
export function showTransferCompleteToast(
  applicationContext: ApplicationContext,
  endedDownload: OngoingDownload,
  localPath: string | undefined,
) {
  const isBatchImport = !isEmpty(endedDownload.batchImportId);
  if (isBatchImport) {
    return;
  }

  const suffix = localPath ? ` to "${localPath}"` : '';
  let filename = endedDownload.originalFileName ?? 'file';
  let description = '';
  if (endedDownload.artefact === 'proxy') {
    description = ' (proxy)';
  } else if (endedDownload.artefact === 'aaf') {
    const simpleName = getBasenameWithoutExtension(filename, applicationContext.pathSep);
    filename = `${simpleName}.aaf`;
  }

  showToast(`Successfully downloaded ${filename}${description}${suffix}`, TOAST.SUCCESS);
}